"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuizzesItem = void 0;
var React = __importStar(require("react"));
var useHeaderProps_1 = require("../../../hooks/useHeaderProps");
var useDisplayMode_1 = require("../useDisplayMode");
var DropdownOption_1 = require("../../_shared/DropdownOption");
var HeaderLink_1 = require("../../_shared/HeaderLink");
var NavLink_1 = require("../../_shared/NavLink");
var NavMenu_1 = require("../../_shared/NavMenu");
var QuizzesItem = function () {
    var _a = (0, useHeaderProps_1.useHeaderProps)(), _js = _a._js, siteConfiguration = _a.siteConfiguration, activeItem = _a.activeItem, permissions = _a.permissions;
    var displayMode = (0, useDisplayMode_1.useDisplayMode)();
    var links = (function () {
        var result = [
            {
                href: '/Quizzes/Sessions',
                className: 'header-link__quiz-sessions',
                dataFeatureId: 'header_link_quiz_sessions',
                content: _js('Quiz Sessions'),
            },
        ];
        if ((siteConfiguration === null || siteConfiguration === void 0 ? void 0 : siteConfiguration['dev-feature-quizzes-v2']) && (permissions === null || permissions === void 0 ? void 0 : permissions.canIViewQuizLibrary)) {
            result.push({
                href: '/Quizzes',
                className: 'header-link__quiz-library',
                dataFeatureId: 'header_link_quiz_library',
                content: _js('Quiz Library'),
            });
        }
        return result;
    })();
    switch (displayMode) {
        case 'more':
            return (React.createElement(React.Fragment, null, links.map(function (link) { return (React.createElement(DropdownOption_1.DropdownOption, { key: link.dataFeatureId, href: link.href, className: link.className, "data-feature-id": link.dataFeatureId }, link.content)); })));
        case 'hamburger':
            return (React.createElement(React.Fragment, null, links.map(function (link) { return (React.createElement(NavLink_1.NavLink, { key: link.dataFeatureId, href: link.href, className: link.className, "data-feature-id": link.dataFeatureId }, link.content)); })));
        default:
            return links.length === 1 ? (React.createElement(HeaderLink_1.HeaderLink, { href: links[0].href, className: links[0].className, "data-feature-id": links[0].dataFeatureId, underlined: activeItem === 'quizzes' }, _js('Quizzes'))) : (React.createElement(NavMenu_1.NavMenu, null,
                React.createElement(NavMenu_1.NavMenuButton, { underlined: activeItem === 'quizzes', "date-feature-id": "header_dropdown_quizzes" }, _js('Quizzes')),
                React.createElement(NavMenu_1.NavMenuList, null, links.map(function (link) { return (React.createElement(DropdownOption_1.DropdownOption, { key: link.dataFeatureId, href: link.href, className: link.className, "data-feature-id": link.dataFeatureId }, link.content)); }))));
    }
};
exports.QuizzesItem = QuizzesItem;
